import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";

export const RegionalNote = () => {
  const { t } = useLang();
  return (
    <section className="py-14 md:py-20" data-testid="regional-section">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <span className="inline-block h-px w-16 bg-ser-blue mb-8" aria-hidden="true" />
          <p className="font-display italic text-2xl md:text-4xl leading-snug text-navy/90">{t.regional}</p>
          <p className="mt-6 text-xs uppercase tracking-[0.3em] text-navy/45 font-medium">
            El Salvador · Honduras · Guatemala
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export const FinalCta = () => {
  const { lang, t } = useLang();
  return (
    <section className="bg-pastel-yellow py-16 md:py-24 border-t border-ser-yellow/20" data-testid="final-cta-section">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <Reveal>
          <h2 className="font-display text-4xl md:text-6xl leading-[1.05] tracking-tight text-navy">
            {t.finalCta.title}
          </h2>
          {t.finalCta.text && (
            <p className="mt-6 text-base md:text-lg text-navy/70 max-w-xl">{t.finalCta.text}</p>
          )}
          <Link
            to={`/${lang}/contact`}
            data-testid="final-cta-button"
            className="mt-10 inline-block bg-navy text-white text-sm font-medium px-10 py-4 hover:bg-ser-purple transition-colors"
          >
            {t.finalCta.button}
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
